import { Button, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateContentRequestMutation } from '../../../../../../../../../../generated/core-api/graphql-react-query';
import CreateContentRequestItem from '../../../../../ContentRequestPage/Components/RequestListPage/Components/CreateContentRequestItem';
import StyledBox from './styles';

export default function SummaryRequestContent() {
  const [creating, setCreating] = React.useState<boolean>(false);
  const { t } = useTranslation('session');
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useCreateContentRequestMutation({
    onSuccess() {
      setCreating(false);
      enqueueSnackbar(
        t('details.request.created'),
        { variant: 'success' },
      );
      queryClient.invalidateQueries(['listLiveUserContentRequests.infinite']);
      queryClient.invalidateQueries(['getLiveContentRequest']);
    },
    onError(error) {
      console.error('Error creating new content request', error);
    },
  });
  return (
    <StyledBox className="request">
      <Typography variant="subtitle1">{t('details.request.question')}</Typography>
      {creating
        ? (
          <CreateContentRequestItem
            open={creating}
            onClose={() => { setCreating(false); }}
            disableProjectChange
            create={(title, details, projectId) => {
              mutation.mutate({
                input: { title, details, projectId },
              });
            }}
          />
        ) : (
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              setCreating(true);
            }}
          >
            {t('details.request.cta')}
          </Button>
        )}

    </StyledBox>

  );
}
